export default "__VITE_ASSET__BvSLQIJt__"